import Vue from 'vue'
import Router from 'vue-router'
import Main from '@/components/Main'

import index from '@/components/mode/index'
import app from '@/components/mode/app'
import kefu from '@/components/mode/kefu'
import gamePage from '@/components/mode/gamePage'
import payCashier from '@/components/payCashier'
import payResult from '@/components/payResult'
import gameMore from '@/components/gameMore'
import gameList from '@/components/gameList'
import hongbao from '@/components/mode/hongbao'
import activity from '@/components/mode/activity'
import zhanzhu from '@/components/mode/zhanzhu'
import mine from '@/components/mode/mine'
import promote from '@/components/mode/promote'



import login from '@/components/login'
import activityInfo from '@/components/activityInfo'
import zhanzhuye from '@/components/zhanzhuye'
import vip from '@/components/vip'
import applyagent from '@/components/applyagent'
import boutBallBet from '@/components/boutBallBet'
import boutBallBetInfo from '@/components/boutBallBetInfo'
import message from '@/components/message'
import fanshui from '@/components/fanshui'
import fanshuiDetail from '@/components/fanshuiDetail'
import userInfo from '@/components/userInfo'
import userCent from '@/components/userCent'
import wallet from '@/components/wallet'
import addUsdtCard from '@/components/addUsdtCard'
import addBankCard from '@/components/addBankCard'
import usdtmore from '@/components/usdtmore'
import password from '@/components/password'
import welfare from '@/components/welfare'
import betRecord from '@/components/betRecord'
import activityRecord from '@/components/activityRecord'
import activityDetail from '@/components/activityDetail'
import coupon from '@/components/coupon'
import plazza from '@/components/plazza'
import plazzaSearch from '@/components/plazzaSearch'
import plazzaPost from '@/components/plazzaPost'
import report from '@/components/view/report/report'
import security from '@/components/view/security/security'
import setting from '@/components/view/setting/setting'
import loginDevice from '@/components/loginDevice'
import claim from '@/components/claim'
import transRecord from '@/components/transRecord'
import money from '@/components/money'
import recharge from '@/components/recharge'
import payInfo from '@/components/payInfo'

import withdrawal from '@/components/withdrawal'
// import withdrawal from '@/components/view/withdrawal'

import withdrawNew from '@/components/view/withdraw/withdraw'
import rechargeRecord from '@/components/view/recharge/RechargeRecord'


import transfer from '@/components/transfer'
import concise from '@/components/mode/concise'
import moreMenu from '@/components/moreMenu'
import search from '@/components/search'
import noticeDetail from '@/components/noticeDetail'
import notice from '@/components/view/notice'







Vue.use(Router)

export default new Router({
  // mode: 'history',

  // meta: {
  //   requireAuth: true,
  //   keepAlive: true,//是否缓存组件
  //   useCatch:false//是否用缓存
  // }
  mode: 'hash',

  routes: [
    {
      path: '/',
      name: 'Main',
      component: Main,
      children: [
        {
          path: '/',
          name: 'index',
          component: index,
          meta: {
            keepAlive: true,//是否缓存组件
            useCatch: false//是否用缓存
          }
        }, {
          path: '/hongbao',
          name: 'hongbao',
          component: hongbao,

        }, {
          path: '/activity',
          name: 'activity',
          component: activity, meta: {
            keepAlive: true,//是否缓存组件
            useCatch: false//是否用缓存
          }

        }, {
          path: '/promote',
          name: 'promote',
          component: promote, meta: {
            keepAlive: true,
            useCatch: false
          }

        }, {
          path: '/zhanzhu',
          name: 'zhanzhu',
          component: zhanzhu, meta: {
            keepAlive: true,//是否缓存组件
            useCatch: false//是否用缓存
          }

        }, {
          path: '/mine',
          name: 'mine',
          component: mine, meta: {
            keepAlive: true,//是否缓存组件

            useCatch: false,//是否用缓存
            requireAuth: false,

          }

        },
        {
          path: '/app',
          name: 'app',
          component: app, meta: {
            keepAlive: true,//是否缓存组件

            useCatch: false,//是否用缓存
            requireAuth: true,

          }

        },

        {
          path: '/kefu',
          name: 'kefu',
          component: kefu,

        }
      ]
    }, {
      path: '/login',
      name: 'login',
      component: login,
    }, {
      path: '/gamePage',
      name: 'gamePage',
      component: gamePage,
    }, {
      path: '/payCashier',
      name: 'payCashier',
      component: payCashier,
    }, {
      path: '/payResult',
      name: 'payResult',
      component: payResult,
    },{
      path: '/gameMore',
      name: 'gameMore',
      component: gameMore,
    },{
      path: '/moreMenu',
      name: 'moreMenu',
      component: moreMenu,
    },{
      path: '/gameList',
      name: 'gameList',
      component: gameList,
    }, {
      path: '/activityInfo',
      name: 'activityInfo',
      component: activityInfo,
    }, {
      path: '/zhanzhuye',
      name: 'zhanzhuye',
      component: zhanzhuye,
    },
    {
      path: '/vip',
      name: 'vip',
      component: vip,
      meta: {
        keepAlive: true,//是否缓存组件
        useCatch: false//是否用缓存
      }

    }, {
      path: '/applyagent',
      name: 'applyagent',
      component: applyagent,


    }, {
      path: '/boutBallBet',
      name: 'boutBallBet',
      component: boutBallBet,
    }, {
      path: '/boutBallBetInfo',
      name: 'boutBallBetInfo',
      component: boutBallBetInfo,
    }, {
      path: '/message',
      name: 'message',
      component: message, meta: {
        requireAuth: true,
      }
    }, {
      path: '/fanshui',
      name: 'fanshui',
      component: fanshui, meta: {
        requireAuth: true,
      }
    }, {
      path: '/fanshuiDetail',
      name: 'fanshuiDetail',
      component: fanshuiDetail, meta: {
        requireAuth: true,
      }
    }, {
      path: '/userInfo',
      name: 'userInfo',
      component: userInfo,
      meta: {
        requireAuth: true,
      }
    }, {
      path: '/userCent',
      name: 'userCent',
      component: userCent,
      meta: {
        requireAuth: true,
      }
    }, {
      path: '/wallet',
      name: 'wallet',
      component: wallet,
      meta: {
        requireAuth: true,
      }
    }
    , {
      path: '/addBankCard',
      name: 'addBankCard',
      component: addBankCard,
      meta: {
        requireAuth: true,
      }
    }
    , {
      path: '/addUsdtCard',
      name: 'addUsdtCard',
      component: addUsdtCard,
      meta: {
        requireAuth: true,
      }
    }, {
      path: '/usdtmore',
      name: 'usdtmore',
      component: usdtmore,

    }, {
      path: '/password',
      name: 'password',
      component: password,
      meta: {
        requireAuth: true,
      }
    }, {
      path: '/welfare',
      name: 'welfare',
      component: welfare,
      meta: {
        requireAuth: true,
      }
    }
    , {
      path: '/betRecord',
      name: 'betRecord',
      component: betRecord,
      meta: {
        requireAuth: true,
      }
    }
    , {
      path: '/activityRecord',
      name: 'activityRecord',
      component: activityRecord,
      meta: {
        requireAuth: true,
      }
    }, {
      path: '/coupon',
      name: 'coupon',
      component: coupon,
      meta: {
        requireAuth: true,
      }
    }, {
      path: '/plazza',
      name: 'plazza',
      component: plazza,
      meta: {
        requireAuth: true,
      }
    }, {
      path: '/plazzaSearch',
      name: 'plazzaSearch',
      component: plazzaSearch,
      meta: {
        requireAuth: true,
      }
    }, {
      path: '/plazzaPost',
      name: 'plazzaPost',
      component: plazzaPost,
      meta: {
        requireAuth: true,
      }
    }, {
      path: '/report',
      name: 'report',
      component: report,
      meta: {
        requireAuth: true,
      }
    }, {
      path: '/security',
      name: 'security',
      component: security,
      meta: {
        requireAuth: true,
      }
    }, {
      path: '/setting',
      name: 'setting',
      component: setting,
      meta: {
        requireAuth: true,
      }
    }, {
      path: '/loginDevice',
      name: 'loginDevice',
      component: loginDevice,
      meta: {
        requireAuth: true,
      }
    }, {
      path: '/claim',
      name: 'claim',
      component: claim,
      meta: {
        requireAuth: true,
      }
    }, {
      path: '/activityDetail',
      name: 'activityDetail',
      component: activityDetail,
      meta: {
        requireAuth: true,
      }
    }, {
      path: '/transRecord',
      name: 'transRecord',
      component: transRecord,
      meta: {
        requireAuth: true,
      }
    }, {
      path: '/money',
      name: 'money',
      component: money,
      meta: {
        requireAuth: true,
      }
    }, {
      path: '/recharge',
      name: 'recharge',
      component: recharge,
      meta: {
        requireAuth: true,
        keepAlive: true,//是否缓存组件
        useCatch: false//是否用缓存
      }
    }, {
      path: '/rechargeRecord',
      name: 'rechargeRecord',
      component: rechargeRecord,
      meta: {
        requireAuth: true,
      }
    }, {
      path: '/payInfo',
      name: 'payInfo',
      component: payInfo,


    }, {
      path: '/concise',
      name: 'concise',
      component: concise,
      meta: {
        keepAlive: true,//是否缓存组件
        useCatch: false//是否用缓存
      }

    },

    {
      path: '/withdrawal',
      name: 'withdrawal',
      component: withdrawal,
      meta: {
        requireAuth: true,

      }
    }, {
      path: '/withdraw',
      name: 'withdrawNew',
      component: withdrawNew,
      meta: {
        requireAuth: true,
      }
    }, {
      path: '/transfer',
      name: 'transfer',
      component: transfer,
      meta: {
        requireAuth: true,

      }
    }, {
      path: '/search',
      name: 'search',
      component: search,
    }, {
      path: '/noticeDetail',
      name: 'noticeDetail',
      component: noticeDetail,
    }, {
      path: '/notice',
      name: 'notice',
      component: notice,
    }
    , {
      path: '*', // 重定向页面地址
      redirect: '/'
    }

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js